import PropTypes from "prop-types";

export function MyRequestsNotificationDot({
  ringClassName = "ring-white",
  ringColor = null,
}) {
  return (
    <span
      className={`absolute -right-1 top-0 h-2 w-2 rounded-full bg-red-500 ${
        ringColor ? "" : `ring-2 ${ringClassName}`
      }`}
      style={
        ringColor ? { boxShadow: `0 0 0 2px ${ringColor}` } : undefined
      }
      aria-hidden
      data-testid="myRequestsNotificationDot"
    />
  );
}

MyRequestsNotificationDot.propTypes = {
  ringClassName: PropTypes.string,
  ringColor: PropTypes.string,
};
